import { action, computed, observable } from "mobx";
import { CookieNames, getCookie, setCookie } from "../helpers";
import { Logger } from "../helpers";

export type LanguageCode = "en" | "id";

export const LANGUAGE_LABEL = {
  en: "English",
  id: "Bahasa Indonesia",
};

export const KNOWN_LANGUAGES = ["id", "en"];

export class TranslationStore {
  @observable
  language$: LanguageCode = "id";

  @computed
  get languageLabel() {
    return LANGUAGE_LABEL[this.language$];
  }

  constructor() {
    this.setLanguage();
  }

  @action
  switchLanguage = (lang: LanguageCode = "id") => {
    if (!KNOWN_LANGUAGES.includes(lang)) {
      Logger.warn(`Language was set to an unknown language: ${lang}`);
      lang = "id";
    }
    setCookie(CookieNames.Language, lang, 1);
    this.language$ = lang;
  };

  @action
  setLanguage = () => {
    let languageToSet: LanguageCode = "id";
    const crossCookieLanguage = getCookie(CookieNames.Language) as LanguageCode;

    if (KNOWN_LANGUAGES.includes(crossCookieLanguage)) {
      languageToSet = crossCookieLanguage;
    }

    this.language$ = languageToSet;
  };
}
